import { SET_CONSTANT, SET_EVENT, UPDATE_EVENT, APPLY_CHANGES } from '../config/actionTypes';

const ConstantActions = {
	readData: (data) => ({ type: SET_CONSTANT, data }),
	readEventData: (data) => ({ type: SET_EVENT, data }),
	updateEventData: (data) => ({ type: UPDATE_EVENT, data }),
	requestApplyChangesModal: (data) => ({ type: APPLY_CHANGES, data }),
};

export default ConstantActions;
